<template>
  <Modal
    :value="isOpen"
     width="350"
     class-name="vertical-center-modal"
     transfer
     @on-visible-change="showChange"
     :mask-closable="false">
  <p slot="header" style="text-align: center;font-size: 20px; font-weight: 700;font-family: Arial,Hiragino Sans GB,Microsoft Yahei,Microsoft Sans Serif,sans-serif;color: #595959">
    登录
  </p>
  <Form ref="formValidate" :model="loginForm" :rules="ruleValidate">
    <FormItem prop="phone">
      <div class="mobileDiv">
        <span class="text">手机号</span>
        <Input className="mobile" placeholder="请输入手机号" v-model="loginForm.phone"></Input>
      </div>
    </FormItem>
    <FormItem prop="code">
      <div class="mobileDiv">
        <span class="text">验证码</span>
        <Input className="mobile" placeholder="请输入验证码"  v-model="loginForm.code">
          <span slot="append" style="cursor: pointer" @click="getCode">{{this.is_time ? this.time + ' s': this.code }}</span>
        </Input>
      </div>
    </FormItem>
  </Form>
    <button class="loginButton" @click="submit" type="button">
      <span style="color: #fff;font-size: 14px">登&nbsp;&nbsp;&nbsp;&nbsp;录</span>
    </button>
    <div class="register-wrapper" v-if="isEnd">
      <span class="register" @click="toRegister">立即注册</span>
    </div>
    <p class="loginNotice">请用注册时的手机号登录</p>
</Modal>
</template>
<script>
import { Input, FormItem, Form } from 'view-design'
import { getCode, login, getUserInfo } from '@/api/getApi'
import { backMessage, setCookie, ISEND } from "@/js/public"
export default {
  name: 'loginDialog',
  components: { Input, FormItem, Form },
  props: {
    isOpen: {
      type: Boolean
    }
  },
  data () {
    return {
      loginForm: {
        phone: '',
        code: ''
      },
      ruleValidate: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确手机号", trigger: "blur" }
        ]
      },
      is_open: false,
      code: '获取验证码',
      time: 60,
      is_time: false,
      isEnd: ISEND
    }
  },
  methods: {
    showChange (value) {
      this.$emit('update:isOpen', value)
    },
    async getCode () {
      if (this.is_time) {
        return false
      }
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          const params = {
            mobile: this.loginForm.phone,
            scene: 1
          }
          await getCode(params).then((res) => {
            if (res.code !== 200) {
              this.$Message.error(res.message)
              return false
            }
            this.$Message.success(`验证码已发送`)
            this.cutDown()
          }).catch((error) => {
            console.log(error);
          })
        } else {
          backMessage('warning', '请检验手机号码是否正确')
        }
      })
    },
    cutDown () {
      this.is_time = true
      this.Timer = setInterval(() => {
        if (this.time === 0) {
          // this.time = 0
          clearInterval(this.Timer);
          this.time = 60
          this.is_time = false
        } else {
          this.time = this.time - 1
        }
      }, 1000);
    },
    submit () {
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          if (this.loginForm.code === '') {
            this.$Message.error('请输入验证码');
            return false
          }
          const params = {
            code: this.loginForm.code,
            mobile: this.loginForm.phone
          }
          const res = await login(params)
          if (res.code !== 200) {
            this.$Message.error(res.message)
            clearInterval(this.Timer);
            this.time = 60
            this.is_time = false
            return
          }
          this.$Message.success('登录成功');
          setCookie('readStar', res.data.access_token)
          this.jumpRouter()
        }
      })
    },
    async jumpRouter () {
      const res = await getUserInfo()
      if (res.code !== 200) {
        this.$Message.error(res.message)
        return
      }
      const level = res.data.level
      setCookie('level', level)
      setCookie('id', res.data.university_id)
      if (level === 0) {
        this.$router.replace(`/admin/userInfo?id=${res.data.university_id}`)
      }
      if (level === 1) {
        this.$router.push(`/super/orgList`)
      }
    },
    toRegister () {
      this.$emit('update:isOpen', false)
      this.$router.push('/register')
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .ivu-modal {
    top: 0;
  }
  .mobileDiv {
    margin-bottom: 40px;
  }
  .mobile {
    width: 320px;
    height: 40px;
    padding: 6px 11px;
    border: 1px solid #a4a4a4;
    border-radius: 10px;
    position: relative;
  }
  .text {
    width: 52px;
    height: 21px;
    background-color: #fff;
    position: absolute;
    font-size: 12px;
    left: 32px;
    top: -15px;
    z-index: 9999;
    text-align: center;
    font-weight: 700;
  }
  .loginButton {
    background-color: #5096f6;
    width: 320px;
    height: 40px;
    border-radius: 20px;
    border: none;
    cursor: pointer;
  }
  .loginButton:hover {
    opacity: .8;
  }
  .loginNotice {
    font-size: 20px;
    color: #5096f6;
    text-align: center;
    margin-top: 20px;
    padding-bottom: 40px;
  }
  /deep/ .ivu-form-item {
    margin-bottom: 0;
  }
  /deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .ivu-modal {
    top: 0;
  }
  /deep/ .ivu-modal-body {
    padding: 0 16px;
  }
  /deep/ .ivu-modal-footer {
    display: none;
    border: none;
  }
  /deep/ .ivu-modal-header {
    border: none;
    padding: 30px 16px;
    border-radius: 20px;
  }
  /deep/ .ivu-modal .ivu-modal-header {
    border-bottom: none !important;
  }
  /deep/ .ivu-modal-content {
    border-radius: 35px;
  }
  /deep/ .ivu-input {
    height: 40px;
    border: 1px solid #a4a4a4;
    border-radius: 10px;
    padding: 6px 11px;
  }
  /deep/ .ivu-input-group-append, .ivu-input-group-prepend {
    border: 1px solid #a4a4a4;
    border-left: none;
    border-radius: 10px;
    padding: 6px 11px;
    background-color: unset;
    color: #5096f6;
  }
  /deep/ .ivu-input-group .ivu-input {
    border-right: none;
    border-bottom-right-radius: unset;
    border-top-right-radius: unset;
  }
  .register-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .register {
    font-size: 16px;
    margin-top: 10px;
    margin-right: 5px;
    cursor: pointer;
    text-align: right;
    &:hover {
      color: #5096f6;
    }
  }
</style>
